// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2143) return "css/styles.79d51d7f.css";
	// return url for filenames based on template
	return "css/" + chunkId + ".styles." + {"2189":"002f2030","2283":"ef02e611"}[chunkId] + ".css";
};